import React from "react";
import { Link } from "react-router-dom";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "Utils/LoadMask/LoadMask";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import { FiltroPadrePT } from "../../../../components/FiltroPadrePT/FiltroPadrePT";
import { useCierresMensualesProduccion } from "../hooks/useCierresMensualesProduccion";
import { CierresMensualesProduccionTable } from "./CierresMensualesProduccionTable";

// Cierres mensuales de producción ya registrados. Cada uno se abre en su propia
// pantalla para ver lo que quedó congelado en él
export const Listado = () => {
    const hook = useCierresMensualesProduccion();

    return (
        <div className="cierres-mensuales__listado">
            <CardEmpty noShadow>
                <LoadMask loading={hook.cargando} blur>
                    <div className="cierres-mensuales__table-header">
                        <FiltroPadrePT hook={hook} />

                        <Link
                            className="btn btn-primary"
                            to="/produccion-v2/cierres-mensuales/registrar-cierre"
                        >
                            Registrar cierre
                        </Link>
                    </div>

                    <CierresMensualesProduccionTable hook={hook} />

                    <Paginacion
                        cantidadResultados={hook.cantidadResultados}
                        paginaSeleccionada={hook.paginaSeleccionada}
                        setPaginaSeleccionada={hook.setPaginaSeleccionada}
                    />
                </LoadMask>
            </CardEmpty>
        </div>
    );
};
